import { render } from "./BancoCreate.vue?vue&type=template&id=680599e0&scoped=true"
import script from "./BancoCreate.vue?vue&type=script&lang=js"
export * from "./BancoCreate.vue?vue&type=script&lang=js"

import "./BancoCreate.vue?vue&type=style&index=0&id=680599e0&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680599e0"]])

export default __exports__